require('./bootstrap');


function showOnLoad() {
    document.querySelectorAll('.show-on-load').forEach(function (element) {
        element.classList.remove('show-on-load');
    });
}
function hideOnLoad() {
    document.querySelectorAll('.hide-on-load').forEach(function (element) {
        element.classList.add('hide-on-load');
        element.style.display = 'none';
    });
}

document.addEventListener('DOMContentLoaded', function () {
    showOnLoad();
    hideOnLoad();
});  